import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const publisherPayoutAction = createAsyncThunk(
    'publisher-payout',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/publisher-payout`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const publisherPayoutSlice = createSlice({
    name: 'publisher-payout',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(publisherPayoutAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(publisherPayoutAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(publisherPayoutAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const publisherPayoutReducer = publisherPayoutSlice.reducer